import { render, staticRenderFns } from "./SaleItem.vue?vue&type=template&id=2437a856&scoped=true&"
import script from "./SaleItem.vue?vue&type=script&lang=js&"
export * from "./SaleItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleItem.vue?vue&type=style&index=0&id=2437a856&lang=scss&scoped=true&"
import style1 from "./SaleItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437a856",
  null
  
)

export default component.exports